var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "add-to-catalog-piece-content"
  }, [_c('Info', {
    staticClass: "mb-4",
    attrs: {
      "elevation": 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("pieceContentDescription", {
    count: _vm.items.length
  })) + " ")]), _c('Block', {
    staticClass: "add-to-catalog-piece-content__bulk mb-4"
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$translate("bulkUpdateTitle")))]), _c('div', {
    staticClass: "add-to-catalog-piece-content__bulk-layout"
  }, [_c('div', {
    staticClass: "add-to-catalog-piece-content__bulk-fields"
  }, [_c('FormatSelect', {
    attrs: {
      "value": _vm.bulkProductFormat,
      "formats": _vm.formats,
      "label": _vm.$translate('labels.bulkProductFormat'),
      "format-filter": _vm.bulkFormatFilter,
      "show-create-option": _vm.canCreateFormat,
      "variant": "grouped",
      "clearable": "",
      "input-class": "add-to-catalog-piece-content__bulk-format"
    },
    on: {
      "input": _vm.onBulkProductFormatChange,
      "create-format": function createFormat($event) {
        return _vm.createProductFormat(null);
      }
    }
  }), _vm.bulkIsCustom ? _c('div', {
    staticClass: "add-to-catalog-piece-content__bulk-custom-fields"
  }, [_c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.bulkQuantity,
      "label": _vm.$translate('labels.bulkQuantity'),
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "type": "text",
      "inputmode": "decimal",
      "clearable": ""
    },
    on: {
      "input": function input($event) {
        _vm.bulkQuantity = _vm.$utils.normalizeDecimalString($event);
      }
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.bulkPieceContentUnitOptions,
      "label": _vm.$translate('labels.bulkUnit'),
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "clearable": ""
    },
    model: {
      value: _vm.bulkUnit,
      callback: function callback($$v) {
        _vm.bulkUnit = $$v;
      },
      expression: "bulkUnit"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _c('div', {
    staticClass: "add-to-catalog-piece-content__bulk-actions"
  }, [_vm.bulkIsCustom ? [_c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.applyBulkProductFormat(false);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("buttons.applyCustomAll")) + " ")]), _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.applyBulkProductFormat(true);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("buttons.applyFormatEmpty")) + " ")])] : [_c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary",
      "disabled": !_vm.bulkProductFormat
    },
    on: {
      "click": function click($event) {
        return _vm.applyBulkProductFormat(false);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("buttons.applyFormatAll")) + " ")]), _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "color": "primary",
      "disabled": !_vm.bulkProductFormat
    },
    on: {
      "click": function click($event) {
        return _vm.applyBulkProductFormat(true);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("buttons.applyFormatEmpty")) + " ")])]], 2)]), _c('p', {
    staticClass: "text-caption grey--text text--darken-1 mb-0 mt-3"
  }, [_vm._v(" " + _vm._s(_vm.bulkHelpText) + " ")])], 2), _vm._l(_vm.items, function (item) {
    return _c('v-card', {
      key: item.id,
      staticClass: "add-to-catalog-piece-content__card mb-3",
      attrs: {
        "outlined": ""
      }
    }, [_c('v-card-text', {
      staticClass: "py-4"
    }, [_c('div', {
      staticClass: "add-to-catalog-piece-content__card-layout"
    }, [_c('div', {
      staticClass: "add-to-catalog-piece-content__card-product"
    }, [_c('ProductName', {
      attrs: {
        "product": item
      }
    })], 1), _c('div', {
      staticClass: "add-to-catalog-piece-content__card-form"
    }, [_c('FormatSelect', {
      attrs: {
        "value": _vm.formFor(item.id).product_format_id,
        "formats": _vm.formats,
        "label": _vm.$translate('labels.productFormat'),
        "error-messages": _vm.fieldErrors(item.id, 'product_format'),
        "format-filter": function formatFilter(format) {
          return _vm.productFormatFilterFor(item, format);
        },
        "show-create-option": _vm.canCreateFormat,
        "variant": "grouped"
      },
      on: {
        "input": function input($event) {
          return _vm.onProductFormatChange(item.id, $event);
        },
        "create-format": function createFormat($event) {
          return _vm.createProductFormat(item.id);
        }
      }
    }), _vm.isCustomForm(item.id) ? _c('div', {
      staticClass: "add-to-catalog-piece-content__custom-fields"
    }, [_c('v-row', {
      attrs: {
        "dense": ""
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "6"
      }
    }, [_c('v-text-field', {
      attrs: {
        "value": _vm.formFor(item.id).quantity,
        "label": _vm.$translate('labels.pieceContentQuantity'),
        "error-messages": _vm.fieldErrors(item.id, 'quantity'),
        "dense": "",
        "outlined": "",
        "hide-details": "auto",
        "type": "text",
        "inputmode": "decimal"
      },
      on: {
        "input": function input($event) {
          return _vm.updateForm(item.id, 'quantity', $event);
        }
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "6"
      }
    }, [_c('v-select', {
      attrs: {
        "value": _vm.formFor(item.id).unit,
        "items": _vm.pieceContentUnitOptionsFor(item),
        "label": _vm.$translate('labels.pieceContentUnit'),
        "error-messages": _vm.fieldErrors(item.id, 'unit'),
        "dense": "",
        "outlined": "",
        "hide-details": "auto"
      },
      on: {
        "change": function change($event) {
          return _vm.updateForm(item.id, 'unit', $event);
        }
      }
    })], 1)], 1)], 1) : _vm._e(), _vm.stockEquivalence(item) ? _c('v-chip', {
      staticClass: "add-to-catalog-piece-content__equivalence-chip mt-3 mb-0",
      attrs: {
        "small": "",
        "label": "",
        "color": "info",
        "outlined": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "x-small": ""
      }
    }, [_vm._v("mdi-swap-horizontal")]), _vm._v(" " + _vm._s(_vm.stockEquivalence(item)) + " ")], 1) : _vm._e()], 1)])])], 1);
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }